module.exports = __webpack_public_path__ + "img/gb9123_27_c.prt.48068aab.jpg";